"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _utils = require("@material-ui/core/utils");

var _WrapperVariantContext = require("./WrapperVariantContext");

var _PickersPopper = _interopRequireDefault(require("../PickersPopper"));

var _jsxRuntime = require("react/jsx-runtime");

function DesktopWrapper(props) {
  const {
    children,
    DateInputProps,
    KeyboardDateInputComponent,
    onDismiss,
    open,
    PopperProps,
    TransitionComponent
  } = props;
  const ownInputRef = React.useRef(null);
  const inputRef = (0, _utils.useForkRef)(DateInputProps.inputRef, ownInputRef);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_WrapperVariantContext.WrapperVariantContext.Provider, {
    value: "desktop",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(KeyboardDateInputComponent, (0, _extends2.default)({}, DateInputProps, {
      inputRef: inputRef
    })), /*#__PURE__*/(0, _jsxRuntime.jsx)(_PickersPopper.default, {
      role: "dialog",
      open: open,
      anchorEl: ownInputRef.current,
      TransitionComponent: TransitionComponent,
      PopperProps: PopperProps,
      onClose: onDismiss,
      children: children
    })]
  });
}

var _default = DesktopWrapper;
exports.default = _default;